var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 145,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 144.518,
    rx: 48,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.978 99.886c5.062 0 8.647-.914 11.319-2.882v-8.928c-2.742 1.898-6.046 3.093-10.686 3.093-7.803 0-11.037-6.046-11.037-15.606 0-10.053 3.937-15.185 11.107-15.185 4.218 0 8.366 1.476 10.545 2.882v-9.28c-2.32-1.265-6.327-2.179-11.81-2.179-13.99 0-21.231 10.053-21.231 24.113.071 15.396 7.171 23.972 21.793 23.972zm-68.401-4.077V86.88c-3.375 2.32-9.139 4.358-14.412 4.358-8.014 0-11.037-3.796-11.529-11.529h26.433v-5.764c0-16.099-7.1-22.145-17.997-22.145-13.357 0-19.684 10.194-19.684 24.183 0 16.099 7.944 23.902 21.863 23.902 6.96 0 12.092-1.898 15.326-4.077zM128.259 52.645v18.278h-14.622V52.645H102.67v46.327h10.967V79.64h14.622v19.332h10.967V52.645h-10.967zm60.387 37.61h-4.85v-37.61H151.88v3.937c0 11.318-.703 25.94-4.57 33.673h-3.515v19.262h10.123V98.972h24.535v10.545h10.123V90.255h.07zm74.87 8.717h12.443l-17.575-24.956 15.466-21.371h-11.037l-15.466 21.371V52.645H236.38v46.327h10.967V76.195l16.169 22.777zm-52.725-38.594c5.413 0 7.1 4.499 7.1 10.334v.914h-15.255c.281-7.382 2.953-11.248 8.155-11.248zm-37.962 29.877h-15.466c3.023-6.96 3.867-19.613 3.867-27.628v-1.406h11.599v29.034z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.531 98.973H82.354V43.647h-4.992c-9.139 0-13.919 4.57-13.919 11.388 0 7.733 3.304 11.319 10.123 15.888l5.624 3.796-16.169 24.254H51L65.552 77.32c-8.366-5.975-13.076-11.81-13.076-21.652C52.476 43.366 61.053 35 77.292 35h16.169v63.973h.07z",
    fill: "#FC3F1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(51 35)",
    d: "M0 0h258v74.518H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.99ea42fc60ff1f833b8c4f2f558a6c45.svg";
export { ForwardRef as ReactComponent };